import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task02 } from "../../../../../task/course-04/lesson-11/task-02";

const task: Slide = {
  titleHtml: `A circular diaphargm with of mass of 100 g and a compliance of 25 µm/N is attached</br>to a tube of the same diameter (10 cm). Calculate the resonance frequency of the</br>complete system. We give ρ = 1.2 kg/m<sup>3</sup> and c = 342 m/s.`,
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [5, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/11/task/task-2.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
